// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__6ZWdA","navlink":"NavBar_navlink__87+yv","active":"NavBar_active__tscSN"};